/* VAEL Maison — storefront behaviours (vanilla, no dependencies) */
(() => {
  'use strict';
  const CFG = window.VAEL || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } }
  };
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };

  /* ---------------- toast ---------------- */
  let toastTimer;
  function toast(html) {
    const t = $('[data-vael-toast]');
    if (!t) return;
    t.innerHTML = html;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 3200);
  }

  /* ---------------- reveal ---------------- */
  function initReveal(root = document) {
    const els = $$('[data-vael-reveal]', root).filter((el) => once(el, 'vr'));
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-visible')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  }

  /* ---------------- hero slideshow ---------------- */
  function initHero(root = document) {
    $$('[data-vael-hero]', root).forEach((hero) => {
      if (!once(hero, 'vh')) return;
      const slides = $$('.vael-hero__slide', hero);
      const dots = $$('.vael-hero__dot', hero);
      if (slides.length < 2) { slides[0] && slides[0].classList.add('is-active'); playVideo(slides[0]); return; }
      const delay = (parseInt(hero.dataset.autoplay, 10) || 0) * 1000;
      let i = 0, timer = null, paused = false;
      function playVideo(slide) { $$('video', slide || hero).forEach((v) => { v.muted = true; const p = v.play(); p && p.catch(() => {}); }); }
      function go(n) {
        slides[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
        dots[i] && dots[i].setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
        dots[i] && dots[i].setAttribute('aria-current', 'true');
        playVideo(slides[i]);
      }
      function schedule() { clearInterval(timer); if (delay && !paused) timer = setInterval(() => go(i + 1), delay); }
      dots.forEach((d, n) => d.addEventListener('click', () => { go(n); schedule(); }));
      hero.addEventListener('mouseenter', () => { paused = true; clearInterval(timer); });
      hero.addEventListener('mouseleave', () => { paused = false; schedule(); });
      let x0 = null;
      hero.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', (e) => {
        if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); schedule(); }
      });
      document.addEventListener('visibilitychange', () => { document.hidden ? clearInterval(timer) : schedule(); });
      go(0); schedule();
    });
  }

  /* ---------------- carousels ---------------- */
  function initCarousels(root = document) {
    $$('[data-vael-carousel]', root).forEach((c) => {
      if (!once(c, 'vc')) return;
      const track = $('.vael-track', c);
      if (!track) return;
      const prev = $('[data-prev]', c), next = $('[data-next]', c), bar = $('.vael-progress span', c);
      const step = () => { const item = track.firstElementChild; return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 18) : 300; };
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
      next && next.addEventListener('click', () => track.scrollBy({ left: step() }));
      const update = () => {
        if (!bar) return;
        const max = track.scrollWidth - track.clientWidth;
        const ratio = track.clientWidth / track.scrollWidth;
        bar.style.width = Math.max(ratio * 100, 8) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (track.scrollLeft / max) * ((1 / Math.max(ratio, 0.08)) - 1) * 100 : 0) + '%)';
      };
      track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------- tabs ---------------- */
  function initTabs(root = document) {
    $$('[data-vael-tabs]', root).forEach((wrap) => {
      if (!once(wrap, 'vt')) return;
      const tabs = $$('[data-tab]', wrap), panels = $$('[data-panel]', wrap);
      tabs.forEach((t) => t.addEventListener('click', () => {
        tabs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        panels.forEach((p) => { p.hidden = p.dataset.panel !== t.dataset.tab; });
        const panel = panels.find((p) => !p.hidden);
        panel && initCarousels(panel);
      }));
    });
  }

  /* ---------------- wishlist ---------------- */
  const WL_KEY = 'vael:wishlist';
  const wl = { all: () => store.get(WL_KEY, []), has: (h) => wl.all().includes(h) };
  function wlToggle(handle) {
    let list = wl.all();
    const added = !list.includes(handle);
    list = added ? [handle, ...list].slice(0, 60) : list.filter((h) => h !== handle);
    store.set(WL_KEY, list);
    syncWishlistUI();
    document.dispatchEvent(new CustomEvent('vael:wishlist', { detail: { handle, added, list } }));
    toast(added ? 'Favorilerinize eklendi <a href="' + (CFG.wishlistUrl || '/pages/favoriler') + '">Görüntüle</a>' : 'Favorilerinizden çıkarıldı');
    return added;
  }
  function syncWishlistUI() {
    const list = wl.all();
    $$('[data-wishlist-toggle]').forEach((b) => {
      const on = list.includes(b.dataset.wishlistToggle);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on);
      const label = b.querySelector('[data-wishlist-label]');
      if (label) label.textContent = on ? 'Favorilerde' : 'Favorilere ekle';
    });
    $$('[data-wishlist-count]').forEach((el) => { el.textContent = list.length; el.dataset.wishlistCount = list.length; });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    wlToggle(btn.dataset.wishlistToggle);
    btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop');
  }, true);

  async function fetchCard(handle) {
    try {
      const r = await fetch('/products/' + encodeURIComponent(handle) + '?view=vael-card', { credentials: 'same-origin' });
      if (!r.ok) return '';
      return (await r.text()).trim();
    } catch (e) { return ''; }
  }
  async function renderHandles(container, handles) {
    const html = await Promise.all(handles.map(fetchCard));
    container.innerHTML = html.filter(Boolean).join('');
    syncWishlistUI();
    return html.filter(Boolean).length;
  }
  async function initWishlistPage(root = document) {
    const page = $('[data-vael-wishlist-page]', root);
    if (!page || !once(page, 'vw')) return;
    const grid = $('[data-wishlist-grid]', page), empty = $('[data-wishlist-empty]', page), count = $('[data-wishlist-total]', page);
    const render = async () => {
      const list = wl.all();
      if (count) count.textContent = list.length;
      if (!list.length) { grid.innerHTML = ''; empty.hidden = false; return; }
      empty.hidden = true;
      const n = await renderHandles(grid, list);
      if (!n) empty.hidden = false;
    };
    document.addEventListener('vael:wishlist', (e) => { if (!e.detail.added) { const card = grid.querySelector('[data-product-handle="' + e.detail.handle + '"]'); card && card.remove(); if (!wl.all().length) empty.hidden = false; if (count) count.textContent = wl.all().length; } });
    render();
  }

  /* ---------------- cart: quick add + gift wrap ---------------- */
  async function addToCart(variantId, qty = 1, btn) {
    btn && btn.classList.add('is-loading');
    try {
      const actions = window.Shopify && window.Shopify.actions;
      if (actions && actions.updateCart) {
        const res = await actions.updateCart({ lines: [{ merchandiseId: String(variantId), quantity: qty }] }, { event: { context: 'standard-action' } });
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
        actions.openCart && actions.openCart();
      } else {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] }) });
        if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || 'Sepete eklenemedi'); }
        const drawer = document.querySelector('theme-drawer#cart-drawer');
        if (drawer && drawer.open) { window.location.reload(); } else { window.location.href = '/cart'; }
      }
      return true;
    } catch (err) {
      toast(err.message || 'Sepete eklenemedi');
      return false;
    } finally { btn && btn.classList.remove('is-loading'); }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b || b.disabled) return;
    e.preventDefault();
    addToCart(b.dataset.quickAdd, 1, b);
  });
  document.addEventListener('change', async (e) => {
    const cb = e.target.closest('[data-vael-gift-wrap]');
    if (!cb) return;
    try {
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Hediye paketi': cb.checked ? 'Evet' : '' } }) });
      toast(cb.checked ? 'Hediye paketi eklendi' : 'Hediye paketi kaldırıldı');
    } catch (err) { /* ignore */ }
  });

  window.__VAEL = { CFG, $, $$, store, once, toast, initReveal, initHero, initCarousels, initTabs, wl, wlToggle, syncWishlistUI, fetchCard, renderHandles, initWishlistPage, addToCart };
})();